export default "__VITE_ASSET__CufsVnai__"